// extracted by mini-css-extract-plugin
export default {"popup":"ModalOverlay_popup__tb7a3","flareAnimation":"ModalOverlay_flareAnimation__iL-H3"};